import { createContext, useContext, useState, type ReactNode } from 'react'

interface ChatContextValue {
  chatOpen: boolean
  openChat: () => void
  closeChat: () => void
  toggleChat: () => void
}

const ChatContext = createContext<ChatContextValue | null>(null)

export function ChatProvider({ children }: { children: ReactNode }) {
  const [chatOpen, setChatOpen] = useState(false)
  return (
    <ChatContext.Provider
      value={{
        chatOpen,
        openChat: () => setChatOpen(true),
        closeChat: () => setChatOpen(false),
        toggleChat: () => setChatOpen((v) => !v),
      }}
    >
      {children}
    </ChatContext.Provider>
  )
}

export function useChatPanel(): ChatContextValue {
  const ctx = useContext(ChatContext)
  if (!ctx) throw new Error('useChatPanel must be used inside ChatProvider')
  return ctx
}
